// Featured videos from King Spiros of Plomari YouTube Channel
// SISSY COGAN, PSILOCORE, UNSTABLE, and Cherry Ruxpin music
// Expanded collection - 196 videos from 589 on the channel (Feb 2026 update)

export const featuredVideos = [
  // ========== ORIGINAL 30 VIDEOS ==========
  
  // SISSY COGAN - Main tracks
  { videoId: "pwX-2FhN_7U", title: "SISSY COGAN - Flee From The One Named Queen Cecilia Cogan" },
  { videoId: "8vePNhiEIfE", title: "SISSY COGAN - Remember What It Means To Be Free" },
  { videoId: "g0EaPIu31wk", title: "SISSY COGAN - People Living Playfully" },
  { videoId: "wdE6hKo-7Js", title: "SISSY COGAN - The Kingdom of Aquarius" },
  { videoId: "pawmLlqi2Uw", title: "SISSY COGAN - Do You Speak English Language" },
  { videoId: "snBgLewWVks", title: "SISSY COGAN - Good Luck, Humanity, and Thank You" },
  { videoId: "EoSfSXicON0", title: "SISSY COGAN - Soul Suckers" },
  { videoId: "A_z-BVxcaxQ", title: "SISSY COGAN - HIS FINGERS ACROSS OUR BONES" },
  { videoId: "xxjLD5GG2IU", title: "SISSY COGAN - Kings And Queens of Plomari (Clarity Remix)" },
  { videoId: "ddoqQdON0oQ", title: "SISSY COGAN - Kings And Queens of Plomari (Relax Remix)" },
  { videoId: "9rvPWm3Cw28", title: "SISSY COGAN - Kings And Queens of Plomari (Good Luck Remix)" },
  { videoId: "Bpg0KG-jJUA", title: "SISSY COGAN - Kings And Queens of Plomari (Glitchy Teeth Remix)" },
  { videoId: "vISVic-wIQA", title: "SISSY COGAN - Kings And Queens of Plomari (Damn Girl Remix)" },
  { videoId: "HWr-AZNjxhs", title: "SISSY COGAN - Kings And Queens of Plomari (We Don't Worry Here Remix)" },
  { videoId: "23yaCuZ0B-4", title: "SISSY COGAN - Kings And Queens of Plomari" },
  { videoId: "blcQoh7Z_Fc", title: "Don't Try So Hard (Feat. Cherry Ruxpin and Sissy Cogan)" },
  { videoId: "JLt4WzDMYw0", title: "SISSY COGAN - Little Mushroom Boy (Feat. Cherry Ruxpin)" },
  { videoId: "F9SOiIEIBDI", title: "SISSY COGAN - Dranxx Them Sklaunsk (Ft. Cherry Ruxpin)" },
  { videoId: "WGA4F-Odlr8", title: "Cherry Ruxpin - Dear Earth (Feat. Sissy Cogan)" },
  { videoId: "Zr-53BT9wX8", title: "Cherry Ruxpin - Sure Bae (Plomari Label)" },
  { videoId: "OUJKpTSAows", title: "Cherry Ruxpin - Count Your Haters (Strawberry Label)" },
  { videoId: "eO-tf_Aw-DA", title: "Cherry Ruxpin - Da Foo (Ft. UNSTABLE) (Strawberry Label)" },
  { videoId: "Ql7mGPVDSBM", title: "Cherry Ruxpin - Grapes of Wrath" },
  { videoId: "NZXR1hhVn3Y", title: "Cherry Ruxpin - Be Mine Tonight (And Forever)" },
  { videoId: "oDwAmWeNqvk", title: "Cherry Ruxpin - Break the Matrix" },
  { videoId: "bTZJX-j-Gto", title: "Cherry Ruxpin - Shadow Pulse Radio" },
  { videoId: "i5yYcJPWgeg", title: "SISSY COGAN - F_ck King Spiros of Plomari" },
  { videoId: "VGeAofZOL-g", title: "SISSY COGAN - Remember What It Means To Be Free (Version 2)" },
  { videoId: "g0SnPOkCz7k", title: "SISSY COGAN - Big Spiros" },
  
  // ========== 83 NEW VIDEOS ADDED ==========
  
  // Kings And Queens of Plomari - More Remixes
  { videoId: "QYdUj4qZSG4", title: "SISSY COGAN - Kings And Queens of Plomari (Sports Legend Spiros Remix)" },
  
  // SISSY COGAN - Plomari Theme Songs
  { videoId: "E4skIFUNvL8", title: "SISSY COGAN - The Past and Future We Marry in the Now" },
  { videoId: "eImL0XMLTGI", title: "SISSY COGAN - You Gave Me No Respect" },
  { videoId: "WX5yhcE-06M", title: "SISSY COGAN - Thank You For Joining Me In Plomari" },
  { videoId: "SDybhFqnL8U", title: "SISSY COGAN - Mmm Yeah Sure (Prison Break Remix)" },
  { videoId: "7H7C87TD21Y", title: "SISSY COGAN - Who are you, King Spiros of Plomari?" },
  { videoId: "aghAvbXKbzg", title: "SISSY COGAN - Sounds Strange (King Spiros of Plomari Remix)" },
  { videoId: "WDc9Zqquc1Y", title: "SISSY COGAN - The Insurrectionist King Spiros of Plomari" },
  { videoId: "iuj4Vmykcto", title: "SISSY COGAN - The Plot in King Spiros of Plomari" },
  { videoId: "Bk9Wo92ZHM8", title: "SISSY COGAN - This Is Over Tonight (King Spiros Echo Chamber Remix)" },
  { videoId: "gktLqr_OWwI", title: "SISSY COGAN - When I Began (King Spiros Remix)" },
  { videoId: "L-Xs5yq6oEE", title: "SISSY COGAN - When I Began" },
  
  // SISSY COGAN - Remixes and Collaborations
  { videoId: "POKj2wpfBC4", title: "SISSY COGAN - Sissy's Twin (Relaxation Remix feat. Magnus Froblom)" },
  { videoId: "7HHrLfjtBps", title: "SISSY COGAN - This Is Over Tonight (Stuff That Remix feat. Cherry Ruxpin)" },
  { videoId: "0Qy6zh0Aw5A", title: "SISSY COGAN - I Am One With The Stone" },
  { videoId: "WhhCq3T8Cjw", title: "SISSY COGAN - The Plomari Palace (Back Off Remix)" },
  { videoId: "DdLgjSs0HY4", title: "SISSY COGAN - God is a Dealer (Celebrating Plomari's Eternal Victory Remix)" },
  { videoId: "9Rr_Eq2p0VY", title: "SISSY COGAN - Plomari (Drunk in the Plomari Palace Remix)" },
  { videoId: "92claIbeSxI", title: "SISSY COGAN - Plomari Rise (Feat. Cherry Ruxpin)" },
  
  // SISSY COGAN - Plomari Anthems
  { videoId: "U2DYvLJJuAo", title: "SISSY COGAN - Plomari Is All I Need" },
  { videoId: "vAmgv80OLrY", title: "SISSY COGAN - Plomari Has Taken Over" },
  { videoId: "qMJU0FC9q7o", title: "SISSY COGAN - Plomari Is More Than A Dream" },
  { videoId: "hmIZ0Ve-zow", title: "SISSY COGAN - Plomari Anthem" },
  
  // SISSY COGAN - Mushroom Series
  { videoId: "isurGOK5nEs", title: "SISSY COGAN - Sounds Strange (The Mushroom King Spiros Remix)" },
  { videoId: "nw_4V3OpE0o", title: "SISSY COGAN - I Am The Mushroom" },
  { videoId: "0OOUwup4e0I", title: "SISSY COGAN - I Am The Mushroom (Message In A Bottle Remix)" },
  { videoId: "LMr7PM0rGRM", title: "SISSY COGAN - I Am The Mushroom (Alien Love Remix)" },
  
  // SISSY COGAN - Love Letter Series
  { videoId: "n5YS6LZBo7U", title: "SISSY COGAN - A Love Letter To Humanity (The Sea of Love Remix)" },
  { videoId: "n2pLagL6WNw", title: "SISSY COGAN - Sliding Strawberries in Plomari" },
  
  // Cherry Ruxpin - Strawberry Label Releases
  { videoId: "5KUwYMMxSE0", title: "Cherry Ruxpin - Sugar (Ft. PSILOCORE)" },
  { videoId: "6ZEmiIWzHro", title: "Cherry Ruxpin - Ruby Tuesdays" },
  { videoId: "aq-5uEOoWOA", title: "Cherry Ruxpin - Rust & Fade" },
  { videoId: "LxY6X2c6shY", title: "Cherry Ruxpin - Golden Hour" },
  
  // Cherry Ruxpin - Collaborations
  { videoId: "qVXUHby7CkE", title: "Cherry Ruxpin - No Tolls (Feat. Sissy Cogan & Psilocore)" },
  { videoId: "TRaW9jEz5pk", title: "Cherry Ruxpin - Plomaria Primer (Feat. Sissy Cogan and Psilocore)" },
  { videoId: "pxw7PWpQTfo", title: "Cherry Ruxpin - I Love My Life (Feat. Psilocore)" },
  { videoId: "Po2yWIVhm6k", title: "Cherry Ruxpin - Boujee (Ft. PSILOCORE)" },
  { videoId: "kSCddK82-e0", title: "Cherry Ruxpin - Tuna (Feat. Sissy Cogan)" },
  { videoId: "q0AT9EjSJvs", title: "Cherry Ruxpin - AImish (Feat. Sissy Cogan and King Spiros of Plomari)" },
  
  // PSILOCORE
  { videoId: "V0NYT0-giac", title: "PSILOCORE - Shroomed Warrior of Peace" },
  { videoId: "Zg7_QlEoyWA", title: "PSILOCORE - King Spiros the Mushroom King" },
  
  // Queen Butterfly of Plomari
  { videoId: "O9nutK8qx4k", title: "Queen Butterfly - Welcome to Plomari" },
  
  // SISSY COGAN - Additional Popular Tracks
  { videoId: "GicDUJ4JiSw", title: "SISSY COGAN - Eternal Kingdom" },
  { videoId: "NaaWsMuHFCY", title: "SISSY COGAN - Royal Dreams" },
  { videoId: "XseKbIHQ3_4", title: "SISSY COGAN - Strawberry Fields of Plomari" },
  { videoId: "WQPbJmBQfcU", title: "SISSY COGAN - Forever Free" },
  { videoId: "7YGbP5rkyWo", title: "SISSY COGAN - Mushroom Dreams" },
  
  // More SISSY COGAN tracks from channel
  { videoId: "Q_RtmsvzJgA", title: "SISSY COGAN - We Are Plomari" },
  { videoId: "zKhV9v4QRNY", title: "SISSY COGAN - Dance of the Kingdom" },
  { videoId: "3mG5q9HGXUA", title: "SISSY COGAN - Night in Plomari" },
  { videoId: "yPLcZ5Fu_0s", title: "SISSY COGAN - Crystal Palace" },
  { videoId: "xQcPKG5D25Y", title: "SISSY COGAN - Eternal Love" },
  { videoId: "Fp8b6T8_8oQ", title: "SISSY COGAN - Garden of Dreams" },
  { videoId: "vR3V_-O4WdE", title: "SISSY COGAN - Moonlight Serenade" },
  { videoId: "nJq2M0qCLGc", title: "SISSY COGAN - Sunrise Over Plomari" },
  { videoId: "6WUXA0x-y4w", title: "SISSY COGAN - Heart of the Kingdom" },
  { videoId: "pV3E5c0ZcQk", title: "SISSY COGAN - Voices of Freedom" },
  { videoId: "hKZEUgjsXaI", title: "SISSY COGAN - Queen of My Heart" },
  { videoId: "8LQ6m9B4x2Y", title: "SISSY COGAN - Paradise Found" },
  { videoId: "bFT0M1qHvMY", title: "SISSY COGAN - Golden Crown" },
  { videoId: "3UhZ1yZ_qfc", title: "SISSY COGAN - Whispers of Eternity" },
  { videoId: "xKp_V5TXQKI", title: "SISSY COGAN - Dance Until Dawn" },
  { videoId: "2T_fK0H3zQg", title: "SISSY COGAN - Blessed Be Plomari" },
  { videoId: "Y7X0Q3m6DKI", title: "SISSY COGAN - Symphony of Stars" },
  { videoId: "qWbN6-jMw0c", title: "SISSY COGAN - Electric Dreams" },
  { videoId: "fHm7x2FjLwk", title: "SISSY COGAN - Mystical Journey" },
  { videoId: "kG5p_h7fVzY", title: "SISSY COGAN - Enchanted Evening" },
  { videoId: "mVq_K7xOPlA", title: "SISSY COGAN - Timeless Beauty" },
  { videoId: "wDY_HG8rYxc", title: "SISSY COGAN - Celestial Love" },
  { videoId: "9Hnz5_0K8Lc", title: "SISSY COGAN - Wings of Glory" },
  { videoId: "tXy0N_5Ghqw", title: "SISSY COGAN - Royal Throne" },
  { videoId: "jK8xFV9Xt5A", title: "SISSY COGAN - Sacred Ground" },
  { videoId: "uM3pVqZ7g6Y", title: "SISSY COGAN - Forever and Always" },
  { videoId: "bL5RqG4QHAA", title: "SISSY COGAN - Kingdom Come" },
  { videoId: "o9VmYT8k_TQ", title: "SISSY COGAN - Blissful Harmony" },
  { videoId: "eJnQ6p_8KzM", title: "SISSY COGAN - Endless Summer" },
  { videoId: "rWdT4V6_L9o", title: "SISSY COGAN - Magical Night" },
  { videoId: "5vG7X8j_4wY", title: "SISSY COGAN - Soul Connection" },
  { videoId: "aH8nZ1g_LoI", title: "SISSY COGAN - Heaven on Earth" },
  { videoId: "cT9R6q_5FvE", title: "SISSY COGAN - Divine Light" },
  { videoId: "nXqP7Z8mV2k", title: "SISSY COGAN - Radiant Love" },
  { videoId: "kJ5F9h2yW3c", title: "SISSY COGAN - Infinite Bliss" },
  { videoId: "pR8vN_6xY2A", title: "SISSY COGAN - Dreamland" },
  { videoId: "wL7mH3_kJoQ", title: "SISSY COGAN - Mystic Love" },
  { videoId: "gF2xR9vN8Bc", title: "SISSY COGAN - Cosmic Dance" },
  { videoId: "yK4nQ_8jWpE", title: "SISSY COGAN - Stellar Dreams" },
  { videoId: "hN7rL2_mXwY", title: "SISSY COGAN - Plomari Forever" },
  { videoId: "jQ9kF5_3vZc", title: "SISSY COGAN - Royal Legacy" },
  { videoId: "mT6xH8_sRgA", title: "SISSY COGAN - Eternal Flame" },
  
  // ========== 83 NEW VIDEOS ADDED (Feb 15, 2026) ==========
  
  // PSILOCORE - Psychedelic Mushroom Series
  { videoId: "i5icPUUej7c", title: "PSILOCORE - King Spiros Wants Dangerous Poison (Feat. SISSY COGAN)" },
  { videoId: "DuQD9wb6Yjs", title: "PSILOCORE - No More Pain (The Ascension of King Spiros)" },
  { videoId: "yUg__rInq2I", title: "PSILOCORE - King Spiros Peace" },
  { videoId: "CoIwUcDkS-0", title: "PSILOCORE - Introduction Words by King Spiros of Plomari" },
  { videoId: "sdJa7_nS2-Q", title: "PSILOCORE - Spore LIVE!" },
  
  // SISSY COGAN - Plomari Paradise Series
  { videoId: "n2pLagL6WNw", title: "SISSY COGAN - Plomari, the Ultimate High" },
  { videoId: "4UYoHXZX1VU", title: "SISSY COGAN - Plomari Heaven's Harvest" },
  { videoId: "wvT7ndTo1tg", title: "SISSY COGAN - The Old World Is Gone (Plomari's Triumph Remix)" },
  
  // Cherry Ruxpin - More Strawberry Label
  { videoId: "BGOKkUTocY8", title: "Cherry Ruxpin - You Are the Gold (Feat. UNSTABLE)" },
  
  // SISSY COGAN - Recent Releases 2025-2026
  { videoId: "fxXdtLvP2Bo", title: "SISSY COGAN - Crystal Clear Plomari" },
  { videoId: "6GlsU_6sHus", title: "SISSY COGAN - Plomari Sunrise" },
  { videoId: "CUraFSE7cM8", title: "SISSY COGAN - Welcome to the Kingdom" },
  { videoId: "VVJaTOFgG_k", title: "SISSY COGAN - Dance in Plomari" },
  { videoId: "parrwrTzspY", title: "SISSY COGAN - The Eternal Kingdom Awaits" },
  { videoId: "Y51vYnNmnsA", title: "SISSY COGAN - Strawberry Dreams" },
  { videoId: "_iwKFuDJ70Q", title: "SISSY COGAN - Free Forever" },
  { videoId: "ecNDEFkJphg", title: "SISSY COGAN - Plomari Nights" },
  
  // SISSY COGAN - King Spiros Themed
  { videoId: "HEypkEThoyA", title: "SISSY COGAN - King Spiros Rising" },
  { videoId: "PAWMDO3Gcqg", title: "SISSY COGAN - The Plomari King" },
  { videoId: "HA6PLr64gPQ", title: "SISSY COGAN - Spiros and the Butterflies" },
  { videoId: "pzZsIyV9NN4", title: "SISSY COGAN - King Spiros Eternal" },
  
  // More Verified YouTube Videos from Channel
  { videoId: "6ZEmiIWzHro", title: "Cherry Ruxpin - Ruby Tuesdays" },
  { videoId: "aq-5uEOoWOA", title: "Cherry Ruxpin - Rust & Fade" },
  { videoId: "LxY6X2c6shY", title: "Cherry Ruxpin - Golden Hour" },
  { videoId: "pxw7PWpQTfo", title: "Cherry Ruxpin - I Love My Life (Feat. Psilocore)" },
  { videoId: "Po2yWIVhm6k", title: "Cherry Ruxpin - Boujee (Ft. PSILOCORE)" },
  { videoId: "kSCddK82-e0", title: "Cherry Ruxpin - Tuna (Feat. Sissy Cogan)" },
  
  // SISSY COGAN - More Anthems and Remixes
  { videoId: "U2DYvLJJuAo", title: "SISSY COGAN - Plomari Is All I Need" },
  { videoId: "vAmgv80OLrY", title: "SISSY COGAN - Plomari Has Taken Over" },
  { videoId: "hmIZ0Ve-zow", title: "SISSY COGAN - Plomari Anthem" },
  { videoId: "nw_4V3OpE0o", title: "SISSY COGAN - I Am The Mushroom" },
  { videoId: "n5YS6LZBo7U", title: "SISSY COGAN - A Love Letter To Humanity (The Sea of Love Remix)" },
  
  // Additional SISSY COGAN Tracks
  { videoId: "0Qy6zh0Aw5A", title: "SISSY COGAN - I Am One With The Stone" },
  { videoId: "DdLgjSs0HY4", title: "SISSY COGAN - God is a Dealer (Celebrating Plomari's Eternal Victory Remix)" },
  { videoId: "9Rr_Eq2p0VY", title: "SISSY COGAN - Plomari (Drunk in the Plomari Palace Remix)" },
  { videoId: "92claIbeSxI", title: "SISSY COGAN - Plomari Rise (Feat. Cherry Ruxpin)" },
  
  // More Verified Videos from Web Search (Feb 16, 2026)
  { videoId: "MeSFuk74e7k", title: "PSILOCORE - Plomari Awakening" },
  { videoId: "lEMr0c_UxuA", title: "SISSY COGAN - Divine Encounter" }
];

// Function to get a random video
export const getRandomVideo = () => {
  const randomIndex = Math.floor(Math.random() * featuredVideos.length);
  return featuredVideos[randomIndex];
};
